<template>
    <div>
        <div class="row vh-100 overflow-x-hidden" v-if="isLoginRegisterPage">
            <div class="col-6 p-0 bg-cover-center ml-minus-5px d-none d-lg-block login-right-img"
                 v-bind:style="{'background-image':'url(' + require('@/assets/img/login-right-bg.jpg')+')'}">
                <div class="login-text">
                    {{ $t('bahcesehir_university') }} <br>
                    {{ $t('bisep') }} {{ $t('application_system') }}
                </div>
            </div>
            <div class="col-12 col-lg-6 bg-white rounded-lg mr-0 mr-md-minus-5px shadow">
                <div class="d-flex flex-column h-100">
                    <div class="flex-grow-1 w-100 d-flex flex-row align-items-center">
                        <slot></slot>
                    </div>
                    <div class="language mx-auto d-flex mb-4">
                        <a class="small text-center d-block mx-2 cursor-pointer"
                           :class="$i18n.locale=='tr' ? 'text-muted':'text-body'"
                           @click="changeLocale('tr')">

                        </a>
                        <a class="small text-center d-block mx-2 cursor-pointer  text-body"
                           :class="$i18n.locale=='en' ? 'text-muted':'text-body'"
                           @click="changeLocale('en')">

                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex vh-100 overflow-x-hidden" v-else>
            <div class="pr-lg-0 p-0 bg-cover-center login-right-img ml-0 d-none d-lg-flex"
                 style="flex-basis:350px; min-width: 350px;"
                 :style="{'background-image':'url(' + require('@/assets/img/login-right-bg.jpg')+')'}">
                <div class="login-text font-size-2 px-5" style="width:350px; ">
                    {{ $t('bahcesehir_university') }} <br>
                    {{ $t('bisep') }} {{ $t('application_system') }}
                </div>
            </div>
            <div class="flex-grow-1 p-0 vh-100 overflow-y-scroll">
                <header class="header">
                    <b-navbar class="p-0">
                        <div class="d-flex align-items-center justify-content-between w-100 py-3 py-lg-4">
                            <div class="mb-0 ml-4 ml-lg-5 bg-transparent small text-uppercase p-0">
                                <h5 class="m-0 d-flex align-items-center font-weight-bold">
                                    <span class="d-block d-md-none">
                                        {{ $t('bisep').toUpper() }}<br>{{ $t('application_system').toUpper() }}
                                    </span>
                                    <span class="d-none d-md-block">
                                        {{ $t('bisep').toUpper() }} {{ $t('application_system').toUpper() }}
                                    </span>
                                </h5>
                            </div>
                            <b-navbar-nav class="ml-auto pr-4 pr-lg-5 align-items-center flex-row gap-2">
                                <b-button class="btn-40 d-flex shadow-sm align-items-center justify-content-center" variant="outline-secondary"
                                          @click="changeLocale('en')" v-if="locale ==='tr'">
                                    EN
                                </b-button>
                                <b-button class="btn-40 d-flex shadow-sm align-items-center justify-content-center" variant="outline-secondary"
                                          @click="changeLocale('tr')" v-else>
                                    TR
                                </b-button>
                                <b-button variant="outline-primary" class="d-flex align-items-center py-2 px-3">
                                    <CountDown
                                        :localStorageKey="'bisepSessionDeadline'"
                                        :showDays="false"
                                        :show-hours="false"
                                        ref="countdown"
                                        customClass="text-primary font-weight-bold"
                                        @expired="onCountdownExpired"
                                    />
                                </b-button>
                                <b-button variant="outline-danger" @click="logout" class="d-flex align-items-center py-2 px-3">
                                    <i class="ri-logout-circle-line mr-md-1 top-minus-1 align-middle"></i>
                                    <span class="d-none d-md-inline">{{ $t('logout') }}</span>
                                </b-button>
                            </b-navbar-nav>
                        </div>
                    </b-navbar>
                </header>
                <div class="height-80 mr-minus-15 bg-cover-center login-right-img ml-0 position-relative d-lg-none"
                     v-bind:style="{'background-image':'url(' + require('@/assets/img/login-right-bg.jpg')+')'}">
                    <div class="login-text px-5" style="font-size: 1.3rem">
                        {{ $t('bahcesehir_university') }} <br>
                        {{ $t('bisep') }} {{ $t('application_system') }}
                    </div>
                </div>
                <div class="p-2 p-md-3 p-lg-5">
                    <slot :countDown="$refs.countdown ? $refs.countdown.timeLeft.difference : null"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CountDown from "@/components/elements/CountDown.vue";
import { localeChanged } from 'vee-validate';
export default {
    components: {
        CountDown
    },
    computed: {
        isLoginRegisterPage() {
            let links = [
                '/bisep/application/login',
                '/bisep/application/register',
                '/bisep/application/forgot/password'
            ]
            return links.includes(this.$route.path);
        },
        locale() {
            return this.$store.getters['getLocale'] || this.$i18n.locale;
        }
    },
    beforeCreate() {
        this.$store.dispatch('bisepApplication/initData');
    },
    methods: {
        changeLocale(locale) {
            this.$i18n.locale = locale;
            this.$store.commit('setLocale', locale)
            localeChanged();
        },
        onCountdownExpired() {
            this.logout()
        },

        logout(){
            this.$store.dispatch('bisepApplication/logout')
        }
    },
    created() {
    }
}
</script>
